import {
    defaultRecaptchaMessage,
    getRecaptchaMessage,
} from "./utilities/getRecaptchaMessage";
import { formDataToObject } from "./utilities/formdataToObject";

export default function (el, directive, utilities) {
    switch (directive.value) {
        case "input": {
            handleInput(el, directive, utilities);
            break;
        }
        case "error": {
            handleError(el, directive, utilities);
            break;
        }
        default: {
            handleRoot(el, directive, utilities);
            break;
        }
    }
}

function handleRoot(el, directive, { Alpine, evaluate }) {
    if (el.tagName !== "FORM") {
        throw new Error("x-form directive must be used on a form element.");
    }

    const options = evaluate(directive.expression);

    Alpine.bind(el, {
        "x-data"() {
            return {
                isSubmitting: false,
                errors: {},
                message: "",
                stringResources: {
                    recaptchaMessage: defaultRecaptchaMessage,
                },
            };
        },
        "x-init"() {
            getRecaptchaMessage().then((message) => {
                this.stringResources.recaptchaMessage = message;
            });
        },
        "x-on:submit.prevent"() {
            this.errors = {};
            this.isSubmitting = true;

            const formData = new FormData(el);
            const formDataObj = formDataToObject(formData);
            const errors = {};

            if (
                options.schema &&
                typeof options.schema === "object" &&
                options.schema !== null &&
                "safeParse" in options.schema
            ) {
                const validation = options.schema.safeParse(formDataObj);

                if (!validation.success) {
                    const formattedErrors = validation.error.format();

                    Object.keys(formattedErrors).forEach((key) => {
                        if (key !== "_errors") {
                            errors[key] = formattedErrors[key]._errors[0];
                        }
                    });

                    this.errors = errors;
                    this.isSubmitting = false;

                    console.log({ formData: formDataObj, formattedErrors, errors });
                    return;
                }
            }

            grecaptcha.ready(async () => {
                const privateKey = document.getElementById("recaptchaSiteKey").value;

                try {
                    const token = await grecaptcha.execute(privateKey, {
                        action: "submit",
                    });
                    const isFormData = el.enctype === 'multipart/form-data'
                    let body

                    if (isFormData) {
                        formData.set('ipAddress', document.getElementById('ipAddress')?.value || '')
                        formData.set('referrerUrl', document.referrer);
                        formData.set('recaptcha', token);
                        body = formData;
                    } else {
                        body = JSON.stringify({
                            ...formDataObj,
                            ipAddress: document.getElementById('ipAddress')?.value || '',
                            referrerUrl: document.referrer,
                            recaptcha: token,
                        })
                    }

                    const result = await fetch(el.action, {
                        method: el.method || "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": isFormData ? 'multipart/form-data' : 'application/json',
                        },
                        body,
                    });
                    this.isSubmitting = false;
                    if (!result.ok) {
                        throw new Error("Unable to submit form.");
                    }

                    const json = await result.json();

                    if (!json.isSuccess) {
                        throw json;
                    }

                   

                    if (options.onSuccess && typeof options.onSuccess === "function") {
                        options.onSuccess(json);
                    }
                } catch (error) {
                    this.isSubmitting = false;
                    console.error(error);

                    if (typeof error === 'object' && error !== null && 'message' in error) {
                        this.message = error.message;
                    }

                    if (options.onError && typeof options.onError === "function") {
                        options.onError(error);
                    }
                    
                   
                  
                }
            });
        },
    });
}

function handleInput(el, directive, { Alpine }) {
    if (!["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName)) {
        throw new Error(
            "x-form:input can only be used on input, textarea, and select elements."
        );
    }

    Alpine.bind(el, {
        "x-bind:aria-errormessage"() {
            return this.$id(`alpine-form-${directive.expression}`);
        },
        "x-bind:aria-invalid"() {
            return directive.expression in this.$data.errors;
        },
        "x-bind:class"() {
            return directive.expression in this.$data.errors ? "border-alert" : "";
        },
    });
}

function handleError(el, directive, { Alpine }) {
    Alpine.bind(el, {
        role: "status",
        "aria-live": "polite",
        "x-bind:id"() {
            return this.$id(`alpine-form-${directive.expression}`);
        },
        "x-show"() {
            return directive.expression in this.$data.errors;
        },
        "x-text"() {
            return directive.expression in this.$data.errors
                ? this.$data.errors[directive.expression]
                : "";
        },
    });
}
